/**
 * FartCalculations - Pure calculation functions for fart damage/cost
 * 
 * Extracted to a separate file to avoid Phaser dependency in tests.
 * These values come from game.config.ts but are duplicated here
 * to keep this module dependency-free for testing.
 */

// Config constants - authoritative source for fart balance
// These were originally in game.config.ts but moved here for framework independence
export const FART_MIN_COST = 5;
export const FART_MAX_COST = 50;
export const FART_MIN_DAMAGE = 5;
export const FART_MAX_DAMAGE = 50;
export const FART_MIN_STUN = 250;
export const FART_MAX_STUN = 1500;

export interface FartParams {
    damage: number;
    stunDuration: number;
    startScale: number;
    endScale: number;
}

/**
 * Calculate fart parameters based on charge percentage
 * @param chargePercent - 0.0 to 1.0 representing charge level
 */
export function calculateFartParams(chargePercent: number): FartParams {
    return {
        damage: FART_MIN_DAMAGE + (FART_MAX_DAMAGE - FART_MIN_DAMAGE) * chargePercent,
        stunDuration: FART_MIN_STUN + (FART_MAX_STUN - FART_MIN_STUN) * chargePercent,
        startScale: 0.5 + 1.0 * chargePercent,
        endScale: 2.0 + 3.0 * chargePercent,
    };
}

/**
 * Calculate fart cost based on charge percentage
 * @param chargePercent - 0.0 to 1.0 representing charge level
 */
export function calculateFartCost(chargePercent: number): number {
    return FART_MIN_COST + (FART_MAX_COST - FART_MIN_COST) * chargePercent;
}

/**
 * Calculate affordable charge percentage based on current capacity
 * @param capacity - Current capacity
 * @returns The maximum charge percent the player can afford
 */
export function calculateAffordablePercent(capacity: number): number {
    if (capacity < FART_MIN_COST) return 0;
    return (capacity - FART_MIN_COST) / (FART_MAX_COST - FART_MIN_COST);
}
